import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface NavItem {
  id: string;
  label: string;
}

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  @Input({ required: true }) pseudo!: string;
  @Input({ required: true }) fullName!: string;
  @Input() navItems: NavItem[] = [];
  @Input() isDark = true;

  @Output() toggleTheme = new EventEmitter<void>();

  isMenuOpen = false;

  onToggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  onNavigate(): void {
    this.isMenuOpen = false;
  }
}
